import { downloadOfficialDocumentAttachment } from '../../../api/officialDocument';
import { OfficialDocument } from '../../../types/officialDocument';
import ApprovalStampBox from '../ApprovalStampBox';
import { PreviewAttachmentList } from './previewShared';
import '../../quality/EducationAnnualPlanTab.css';
import '../../quality/QualityShell.css';
import '../../product/InspectionFormSheet.css';
import '../../product/NonconformanceReportPanel.css';

interface Props {
  detail: OfficialDocument;
}

function directionLabel(direction?: string | null) {
  if (direction === 'INCOMING') return '수신';
  if (direction === 'OUTGOING') return '발신';
  return direction || '-';
}

function OfficialDocumentPreviewView({ detail }: Props) {
  return (
    <div className="quality-form">
      <section className="quality-form__section">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 16,
            alignItems: 'flex-start',
            marginBottom: 12,
          }}
        >
          <div>
            <h3 style={{ margin: 0 }}>공문서</h3>
          </div>
          <ApprovalStampBox
            authorName={detail.authorName}
            reviewerName={detail.reviewerName}
            approverName={detail.approverName}
          />
        </div>
        <div className="quality-form__grid">
          <label>
            구분 *
            <input value={directionLabel(detail.direction)} readOnly />
          </label>
          <label>
            문서번호
            <input value={detail.documentNo || '-'} readOnly />
          </label>
          <label>
            문서일
            <input type="date" value={detail.documentDate?.slice(0, 10) || ''} readOnly />
          </label>
          <label className="is-span-2">
            제목 *
            <input value={detail.title || ''} readOnly />
          </label>
          <label className="is-span-2">
            상대 기관/부서
            <input value={detail.counterpart || ''} readOnly />
          </label>
          <label className="is-span-2">
            내용
            <textarea rows={8} value={detail.content || ''} readOnly />
          </label>
          <label className="is-span-2">
            비고
            <textarea rows={3} value={detail.remark || ''} readOnly />
          </label>
        </div>
      </section>

      <section className="quality-form__section">
        <div style={{ marginBottom: 8 }}>
          <h3 style={{ margin: 0 }}>첨부파일</h3>
        </div>
        <PreviewAttachmentList
          files={detail.attachments}
          onDownload={(file) =>
            void downloadOfficialDocumentAttachment(
              detail.officialDocumentId,
              file.attachmentId,
              file.fileName
            ).catch(() => undefined)
          }
        />
      </section>
    </div>
  );
}

export default OfficialDocumentPreviewView;
